import { apiClient } from "../config";

async function getAllOrganizations(queryParams: any) {
  const res = await apiClient.get(`/admin/organizations`, {
    params: queryParams,
  });
  return res.data;
}

export default getAllOrganizations;
